import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { TICKET_CATEGORIES_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import { useAlert } from "../alerts/AlertContext";
import TicketCategoryDialog from "./TicketCategoryDialog";

function TicketCategory() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getCategories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(TICKET_CATEGORIES_URL);
      setData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setError("Failed to load categories. Please try again.");
      // showAlert("Failed to load categories", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  const columns = [
    {
      field: "name",
      flex: 2,
      headerName: "Category Name",
      renderCell: (params) => params.value,
    },
    {
      field: "active",
      flex: 1,
      headerName: "Status",
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "default"}
          size="small"
          sx={{
            borderRadius: 1,
            fontWeight: 500,
            minWidth: 70,
          }}
        />
      ),
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <TicketCategoryDialog
            editCategoryId={params.row.id}
            categoryName="Edit"
            variant="link"
          />
        </Box>
      ),
    },
  ];

  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getCategories}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView
          rows={data}
          cols={columns}
          initialPageSize={5}
          totalElements={data.length}
          rowHeight={60}
        />
      )}
    </Box>
  );
}

export default TicketCategory;
